module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-up.1f8e18b0.svg";